import * as moment from 'moment'

import { TimeoutPeriodType, TimeoutType, UserTimeoutDTO } from '../../../base/communication/PlayerApiProtocol.generated'
import { isSelfExclusionResponse, PlayerAccountApi } from '../../communication/player-account/PlayerAccountApi'
import { PlayerApi } from '../../communication/player-api/PlayerApi'
import { Injector } from '../../injector'
import { CashierService } from '../../services/CashierService'
import { FeatureToggleService } from '../../services/FeatureToggleService'
import { UserService } from '../../services/UserService'
import { DialogManager } from '../../ui/dialog/DialogManager'

import { createAction, ReduxAction } from '../ReduxUtils'
import { dispatch, getStore } from '../Store'
import { TimeoutTypeDropdownOption } from './ResponsibleGamingConstants'
import { Feature, userFeatureService } from '../../services/UserFeatureService'

export const enum RGTypes {
    SUBMIT_TIMEOUT = 'SUBMIT_TIMEOUT',
    FETCH_TIMEOUTS = 'FETCH_TIMEOUTS',
    RECEIVED_TIMEOUTS = 'RECEIVED_TIMEOUTS',
    FAILED_TIMEOUTS = 'FAILED_TIMEOUTS',
    FAILED_EXCLUSIONS = 'FAILED_EXCLUSIONS',
    SELECT_TIMEOUT_TYPE = 'SELECT_TIMEOUT_TYPE',
    SELECT_TIMEOUT_PERIOD = 'SELECT_TIMEOUT_PERIOD',
    SELECT_EXCLUSION_PERIOD = 'SELECT_EXCLUSION_PERIOD',
    SELECT_AGREEMENT = 'SELECT_AGREEMENT',
    SELECT_EXCLUSION_AGREEMENT = 'SELECT_EXCLUSION_AGREEMENT',
    SET_TIMEOUT_SUBMIT_OPEN = 'SET_TIMEOUT_SUBMIT_OPEN',
    SET_EXCLUSION_SUBMIT_OPEN = 'SET_EXCLUSION_SUBMIT_OPEN',
    SET_LIMIT_SUBMIT_OPEN = 'SET_LIMIT_SUBMIT_OPEN',
    FETCH_USER_PURCHASE_LIMITS = 'FETCH_USER_PURCHASE_LIMITS',
    RECEIVED_USER_PURCHASE_LIMITS = 'RECEIVED_USER_PURCHASE_LIMITS',
    FAILED_PURCHASE_LIMITS = 'FAILED_PURCHASE_LIMITS',
	SET_KYC_VERIFICATION_STATUS = 'SET_KYC_VERIFICATION_STATUS',
    SUBMIT_PURCHASE_LIMITS = 'SUBMIT_PURCHASE_LIMITS',
    SET_DAILY_LIMIT_AGREEMENT = 'SET_DAILY_LIMIT_AGREEMENT',
    SET_DAILY_LIMIT_AMOUNT = 'SET_DAILY_LIMIT_AMOUNT',
    SET_WEEKLY_LIMIT_AGREEMENT = 'SET_WEEKLY_LIMIT_AGREEMENT',
    SET_WEEKLY_LIMIT_AMOUNT = 'SET_WEEKLY_LIMIT_AMOUNT',
    SET_MONTHLY_LIMIT_AGREEMENT = 'SET_MONTHLY_LIMIT_AGREEMENT',
    SET_MONTHLY_LIMIT_AMOUNT = 'SET_MONTHLY_LIMIT_AMOUNT',
    BOUND_DAILY_LIMIT_AMOUNT = 'BOUND_DAILY_LIMIT_AMOUNT',
    BOUND_WEEKLY_LIMIT_AMOUNT = 'BOUND_WEEKLY_LIMIT_AMOUNT',
    BOUND_MONTHLY_LIMIT_AMOUNT = 'BOUND_MONTHLY_LIMIT_AMOUNT',
}

export function fetchTimeOuts(): ReduxAction<{}> {
	return createAction(RGTypes.FETCH_TIMEOUTS)
}

export function receivedTimeouts(payload: UserTimeoutDTO[]): ReduxAction<{}> {
	return createAction(RGTypes.RECEIVED_TIMEOUTS, {result: payload})
}
export function timeoutError(): ReduxAction<{}> {
	return createAction(RGTypes.FAILED_TIMEOUTS)
}

export function exclusionError(): ReduxAction<{}> {
	return createAction(RGTypes.FAILED_EXCLUSIONS)
}

export function fetchPurchaseLimits(): ReduxAction<{}> {
	return createAction(RGTypes.FETCH_USER_PURCHASE_LIMITS)
}

export function receivedPurchaseLimits(payload: PurchaseLimitPeriod[]): ReduxAction<{}> {
	return createAction(RGTypes.RECEIVED_USER_PURCHASE_LIMITS, {result: payload})
}

export function purchaseLimitsError(): ReduxAction<{}> {
	return createAction(RGTypes.FAILED_PURCHASE_LIMITS)
}

export function setKycVerificationStatus(isKycVerified: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SET_KYC_VERIFICATION_STATUS, { isKycVerified }))
}

export function submitTimeout(): ReduxAction<{}> {
	return createAction(RGTypes.SUBMIT_TIMEOUT)
}

export function submitPurchaseLimits(): ReduxAction<{}> {
	return createAction(RGTypes.SUBMIT_PURCHASE_LIMITS)
}

export function selectTimeoutType(payload: TimeoutTypeDropdownOption): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SELECT_TIMEOUT_TYPE, payload))
}

export function selectTimeoutPeriod(payload: TimeoutPeriodType): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SELECT_TIMEOUT_PERIOD, payload))
}

export function selectExclusionPeriod(payload: TimeoutPeriodType): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SELECT_EXCLUSION_PERIOD, payload))
}

export function selectAgreement(payload: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SELECT_AGREEMENT, {agreement: payload}))
}

export function selectExclusionAgreement(payload: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SELECT_EXCLUSION_AGREEMENT, {exclusionAgreement: payload}))
}

export function setExclusionSubmitOpen(open: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SET_EXCLUSION_SUBMIT_OPEN, {open}))
}

export function setTimeoutSubmitOpen(open: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SET_TIMEOUT_SUBMIT_OPEN, {open}))
}

export function setLimitSubmitOpen(open: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SET_LIMIT_SUBMIT_OPEN, {open}))
}

export const callSubmitTimeout = (period: string, timeoutType?: TimeoutType, endDate?: Date) => {
	return FeatureToggleService.selfExclusionsPlayerAccountFeature.isEnabled() && timeoutType === TimeoutType.SELF_EXCLUSION ? dispatch => {
		dispatch(submitTimeout())
		PlayerAccountApi
			.createUserSelfExclusion(period)
			.then(_ => fetchUserTimeouts(), () => {
				timeoutType === TimeoutType.SELF_EXCLUSION ? getStore().dispatch(exclusionError())
					: getStore().dispatch(timeoutError())
			} )
	} : dispatch => {
		dispatch(submitTimeout())
		PlayerApi
			.requestUserTimeout(period, timeoutType, endDate)
			.subscribe(_ => fetchUserTimeouts(), () => {
				timeoutType === TimeoutType.SELF_EXCLUSION ? getStore().dispatch(exclusionError())
					: getStore().dispatch(timeoutError())
			} )
	}
}

export const fetchUserTimeouts = () => getStore().dispatch((dispatch) => {
	dispatch(fetchTimeOuts())
	return FeatureToggleService.selfExclusionsPlayerAccountFeature.isEnabled() ? 
		PlayerApi
			.fetchUserTimeouts()
			.toPromise()
			.then(payload => {
				payload = payload.filter(timeout => timeout.timeoutType !== TimeoutType.SELF_EXCLUSION)

				PlayerAccountApi
					.fetchUserSelfExclusion()
					.then((selfExclusion) => {
						if (isSelfExclusionResponse(selfExclusion)) {
							const exclusionAsTimeout: UserTimeoutDTO = {
								id: null, 
								userId: selfExclusion.userId,
								period: selfExclusion.timePeriod as TimeoutPeriodType,
								startDate: new Date(selfExclusion.startDate),
								endDate: new Date(selfExclusion.endDate),
								removedDate: new Date(selfExclusion.removedAt),
								requestedBy: selfExclusion.createdBy,
								removed: selfExclusion.removedAt != null,
								removedBy: selfExclusion.removedBy,
								timeoutType: TimeoutType.SELF_EXCLUSION
							}
							payload = payload.concat(exclusionAsTimeout)
						}
						dispatch(receivedTimeouts(payload))
					}).catch(() => dispatch(exclusionError()))

			}).catch(() => dispatch(timeoutError())) : 
		PlayerApi
			.fetchUserTimeouts()
			.toPromise()
			.then((payload) => dispatch(receivedTimeouts(payload)))
			.catch(() => dispatch(timeoutError())) 
})

export const fetchUserPurchaseLimits = () => getStore().dispatch(_fetchUserPurchaseLimits() as any)
export const _fetchUserPurchaseLimits = () => {
	return dispatch => {
		dispatch(fetchPurchaseLimits())
		Injector.get(CashierService)
			.getUserPurchaseLimits()
			.then(payload => dispatch(receivedPurchaseLimits(payload.purchaseLimits)),
				() => dispatch(purchaseLimitsError()))
	}
}

export function setDailyLimitAgreement(payload: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SET_DAILY_LIMIT_AGREEMENT, {agreement: payload}))
}

export function setDailyLimitAmount(payload: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SET_DAILY_LIMIT_AMOUNT, {amount: payload}))
}

export function setWeeklyLimitAgreement(payload: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SET_WEEKLY_LIMIT_AGREEMENT, {agreement: payload}))
}

export function setWeeklyLimitAmount(payload: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SET_WEEKLY_LIMIT_AMOUNT, {amount: payload}))
}

export function setMonthlyLimitAgreement(payload: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SET_MONTHLY_LIMIT_AGREEMENT, {agreement: payload}))
}

export function setMonthlyLimitAmount(payload: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.SET_MONTHLY_LIMIT_AMOUNT, {amount: payload}))
}

export function boundDailyLimitAmount(payload: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.BOUND_DAILY_LIMIT_AMOUNT, {amount: payload}))
}

export function boundWeeklyLimitAmount(payload: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.BOUND_WEEKLY_LIMIT_AMOUNT, {amount: payload}))
}

export function boundMonthlyLimitAmount(payload: boolean): ReduxAction<{}> {
	return getStore().dispatch(createAction(RGTypes.BOUND_MONTHLY_LIMIT_AMOUNT, {amount: payload}))
}

export const callSubmitLimits = async (limits: CreatePurchaseLimit[]) => {
	const userService = Injector.get(UserService)
	try {
		dispatch(submitPurchaseLimits())
		await userService.createPurchaseLimits(limits)
	} catch {
		dispatch(purchaseLimitsError())
		throw Error(`an error occurred when submitting purchase limits`)
	}
}

/**
 * Logic to trigger a modal popup up if user is timed out for:
 * Buy In,
 * Register,
 * Buying avatars
 */
export const checkTimeOut = (timeoutType: TimeoutType) => {
	let message
	let timeout
	const { loadedTimeouts, userTimeouts, userExclusion } = getStore().getState().player.responsibleGaming
	if (!loadedTimeouts && userFeatureService.doesUserHaveFeature(Feature.GC_AND_SC_PLAY)) return true
	if (userTimeouts) {
		timeout = userTimeouts.find((to) => to.timeoutType === timeoutType)
		const takeabreakMessage = userTimeouts.length === 3 && timeoutType !== TimeoutType.PURCHASE
			? 'dialog-takeabreak.all-games'
			: MESSAGES_FOR_MULTI_TAKE_A_BREAK_TYPE[timeoutType]
		message = takeabreakMessage 
	}

	if (userExclusion) {
		timeout = userExclusion
		message = MESSAGES_FOR_MULTI_TIMEOUT_TYPE[timeout.timeoutType]
	}
    
	if (timeout && userFeatureService.doesUserHaveFeature(Feature.GC_AND_SC_PLAY)) {
		const { endDate, period } = timeout

		let indefiniteMessage
		let endDateMessage

		if (userExclusion) {
			indefiniteMessage = period === 'INDEFINITE' && i18n.t('responsible-gameplay.player-message.exclusion.indefinite')
			endDateMessage = `
                ${i18n.t('responsible-gameplay.player-message.exclusion.end-date')}
                ${moment(endDate).format('MMM DD, YYYY hh:mm A')}
            `
		}
		else {
			indefiniteMessage = period === 'INDEFINITE' && i18n.t('responsible-gameplay.player-message.indefinite-takeabreak-message')
			endDateMessage = `
                ${i18n.t('responsible-gameplay.player-message.end-date-takeabreak')}
                ${moment(endDate).format('MMM DD, YYYY hh:mm A')}
            `
		}
		Injector.get(DialogManager).displayGenericDialog({
			header: 'Error',
			message: `${indefiniteMessage || endDateMessage}
                        <br /><br />
                        ${i18n.t(`responsible-gameplay.player-message.${message}`)}
                        `,
			okButtonText: i18n.t('common.cancel'),
		})
	}
	if (!userFeatureService.doesUserHaveFeature(Feature.GC_AND_SC_PLAY)) {
		timeout = true

		message = userFeatureService.isUserPhase2Restricted
			? 'dialog-blocked.phase-restricted-all-games'
			: 'dialog-blocked.all-games'

		Injector.get(DialogManager).displayGenericDialog({
			header: 'Error',
			message: `${i18n.t(`responsible-gameplay.player-message.${message}`)}`,
			okButtonText: i18n.t('common.cancel'),
		})
	}
	return !!timeout
}

export const userHasTimeout = (timeoutType: TimeoutType) => {
	let timeout
	const { loadedTimeouts, userTimeouts, userExclusion } = getStore().getState().player.responsibleGaming
	if (!loadedTimeouts) return true
	if (userExclusion) return true
	if (userTimeouts) {
		timeout = userTimeouts.find((to) => to.timeoutType === timeoutType)
	}
	return !!timeout
}

const MESSAGES_FOR_MULTI_TIMEOUT_TYPE = {
	POKER: 'dialog.poker',
	CASINO: 'dialog.casino',
	PURCHASE: 'dialog.avatar', // Currently only applicable to avatars
	SELF_EXCLUSION: 'dialog.self-exclusion',
}

const MESSAGES_FOR_MULTI_TAKE_A_BREAK_TYPE = {
	POKER: 'dialog-takeabreak.poker',
	CASINO: 'dialog-takeabreak.casino',
	PURCHASE: 'dialog-takeabreak.avatar', // Currently only applicable to avatars
}
